import styled from '@emotion/styled';
import { rem } from '@utils';

const Wrapper = styled.div<{ isOpen: boolean }>(
  ({ isOpen }) => `
  background: var(--right-panel-background-color);
  border-left: 1px solid var(--right-panel-border-left-color);
  color: var(--right-panel-color);
  display: flex;
  flex-direction: column;
  font-size: ${rem(14)};
  grid-area: e;
  opacity: ${isOpen ? 1 : 0};
  overflow: hidden;
  scale: ${isOpen ? 1 : 0};
  transition: opacity 0.25s ease-in-out;
  width: ${isOpen ? `min(60vw, ${rem(1200)})` : 0};

  && {
    scrollbar-gutter: initial;
  }

  @media (max-width: 1024px) {
    border-left: none;
    height: 100dvh;
    opacity: 1;
    position: fixed;
    right: 0;
    top: 0;
    transform: translate3d(${isOpen ? 0 : 100}%, 0, 0);
    transition: transform 250ms ease-in-out, scale 0ms ${isOpen ? 0 : 250}ms;
    width: 100vw;
    will-change: transform;
    z-index: 5;
  }
`
);

export default {
  Wrapper
};
